import { Select, Text } from '@viapeople/components'
import { useState } from 'react'
import { FormLabelWithTooltip } from './FormLabelWithTooltip'
import type { ComponentProps, SelectFieldCustomProps } from './types'

type FormsSelectFieldProps = ComponentProps & {
	value?: string
	onChange?: (value: string) => void
	readOnly?: boolean
	hasError?: boolean
}

export function FormsSelectField({ component, value, onChange, readOnly, required, hasError }: FormsSelectFieldProps) {
	const { label, labelColor, labelSize, labelWeight, placeholder, options, tooltipEnabled, tooltipText } =
		component.custom as SelectFieldCustomProps
	const [internalValue, setInternalValue] = useState('')

	const handleChange = (val: string) => {
		if (onChange) {
			onChange(val)
		} else {
			setInternalValue(val)
		}
	}

	const selectOptions =
		(typeof options === 'string' &&
			options
				.split(',')
				.filter((o) => o.trim())
				.map((o) => ({ value: o.trim(), label: o.trim() }))) ||
		(Array.isArray(options) && options.map((o) => ({ value: String(o.value), label: o.label ?? String(o.value) }))) ||
		[]

	return (
		<div id={component.id} className='flex flex-col gap-1'>
			{label && (
				<FormLabelWithTooltip
					label={label}
					labelColor={labelColor}
					labelSize={labelSize}
					labelWeight={labelWeight}
					required={required}
					readOnly={readOnly}
					tooltipEnabled={tooltipEnabled}
					tooltipText={tooltipText}
				/>
			)}
			<div className='flex items-center gap-1'>
				{readOnly ? (
					<div className='bg-neutral-50 border border-neutral-200 rounded-md px-6 py-4'>
						<Text>{value}</Text>
					</div>
				) : (
					<Select
						placeholder={placeholder}
						options={selectOptions}
						value={value !== undefined ? value : internalValue}
						onChange={handleChange}
						variant={hasError ? 'error' : 'default'}
					/>
				)}
			</div>
		</div>
	)
}
